/**
 * Route paths for the account feature. The same strings are the sidebar menu
 * keys in `views/Profile`.
 */
export const ACCOUNT_ROUTES = {
  account: "/account",
  profile: "/account/profile",
  password: "/account/password",
  settings: "/account/settings",
} as const;
